export default axios => ({
  /**
   * Возвращает список событии
   *
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  list ({ pageSize = 10, currentPage = 1, searchBy = '', sort = 'id', order = 'DESC' } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get('/web/event/list', { params })
  },
  /**
   * Возвращает данные событии
   *
   * @param id
   * @returns {*}
   */
  event (id) {
    return axios.get(`/web/event/get/${id}`)
  },
  /**
   * Возвращает список участником событии
   *
   * @param id
   * @returns {*}
   */
  members (id) {
    return axios.get(`/web/event/get/${id}/members`)
  },
  /**
   * Удаляет события
   *
   * @param id
   * @returns {*}
   */
  delete (id) {
    return axios.delete(`/web/event/get/${id}`)
  },
  /**
   * Создает событии
   *
   * @param body
   * @returns {*}
   */
  create (body) {
    return axios.post('/web/event/add', body)
  },
  /**
   * Возвращает список событии на карте
   *
   * @returns {*}
   */
  dots () {
    return axios.get('/web/event/maps')
  },
  /**
   * Получить часы для календаря
   *
   * @param id
   * @param date
   * @returns {*}
   */
  calendarHours (id, date) {
    return axios.get(`/web/playground/get/${id}/calendarHours`, {
      params: {
        date
      }
    })
  }
})
